import React from 'react';
import { BoolToString, SortedRegTypeOrder } from 'components';
import _ from 'lodash';
import { getTableColumns } from 'helpers';

const GroupOpenPersonColumns = [
  ...getTableColumns(
    [
      ['personType', 'string', 'Person Type', 'left', true]
    ]
  ),
  {
    name: 'isMandatory',
    type: 'string',
    label: 'Required?',
    align: 'center',
    filterable: true,
    renderCell: data => (<BoolToString boolValue={data && data.isMandatory} />)
  },
  {
    name: 'isMultiple',
    type: 'string',
    label: 'Multiple?',
    align: 'center',
    filterable: true,
    renderCell: data => (<BoolToString boolValue={data && data.isMultiple} />)
  },
  {
    name: 'personRegistrationType',
    type: 'string',
    label: 'Registration Type',
    filterable: true,
    className: 'whitespace-show',
    renderCell: data => {
      const regTypes = _.map(data.openProtPerRegTypeXrefs, 'personRegistrationType');
      const sortedArr = SortedRegTypeOrder(_.uniq(regTypes));
      return (
        <div>
          {sortedArr && sortedArr.join(', ')}
        </div>
      );
    }
  },
  {
    name: 'esysStatus',
    type: 'string',
    label: 'Status',
    align: 'center',
    filterable: true
  }
];

export default GroupOpenPersonColumns;
